import { createRoute, lazyRouteComponent, type AnyRootRoute } from '@tanstack/react-router'
import { buildAppShellRoute, type AppShellRouteOptions } from './features/_shell/routes'
import { buildAuthRoutes } from './features/auth/routes'
import { buildWelcomeRoutes } from './features/welcome/routes'

/**
 * Options the composition root (`apps/viltrapport-web`) uses to inject
 * cross-domain pieces — e.g. chronicle's statistics routes and auth bridge —
 * so clubhouse never imports another domain (RULE-002).
 */
export type ClubhouseRoutesOptions = AppShellRouteOptions

// Keep the existing /status health probe.
function buildStatusRoute<TRoot extends AnyRootRoute>(rootRoute: TRoot) {
  return createRoute({
    getParentRoute: () => rootRoute,
    path: '/status',
    component: lazyRouteComponent(() => import('./StatusPage'), 'StatusPage'),
  })
}

export function buildClubhouseRoutes<TRoot extends AnyRootRoute>(
  rootRoute: TRoot,
  options?: ClubhouseRoutesOptions,
) {
  return [
    buildStatusRoute(rootRoute),
    ...buildAuthRoutes(rootRoute),
    ...buildWelcomeRoutes(rootRoute),
    buildAppShellRoute(rootRoute, options),
  ]
}
